import React, { useMemo, useState } from 'react';
import {
  Image,
  IconButton,
  QuestionIcon,
  MessageIcon,
  Container,
  Row,
  Col,
  DropdownMenu,
  InfoIcon,
} from 'shared-portal-component';

import Avatar from '@/components/atomic/Avatar/Avatar';
import '@/components/molecules/Header/Header.scss';
import { logoutThunk } from '@/store/thunks/auth/logoutThunk';
import { useAppDispatch } from '@/store';
import { showEditUserModal, showUpdatePasswordModal } from '@/store/thunks/ui/uiThunk';

interface LogoProps {
  imageSrc: string;
  alt: string;
}

interface HeaderProps {
  logo: LogoProps;
  customerName: string;
  messageCount: number;
  customerInitials: string;
}

const NO_MESSAGES = 0;

const Header: React.FC<HeaderProps> = ({ logo, customerName, messageCount, customerInitials }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const dispatch = useAppDispatch();

  const menuItems = useMemo(
    () => [
      {
        icon: <InfoIcon size="1x" />,
        label: 'Edit Profile',
        onClick: () => {
          setMenuOpen(false);
          dispatch(showEditUserModal());
        },
      },
      {
        icon: <InfoIcon size="1x" />,
        label: 'Reset Password',
        onClick: () => {
          setMenuOpen(false);
          // dispatch(showUpdatePasswordModal());
        },
      },
      {
        icon: <InfoIcon size="1x" />,
        label: 'Logout',
        onClick: () => {
          setMenuOpen(false);
          void dispatch(logoutThunk());
        },
      },
    ],
    [dispatch]
  );

  return (
    <header className="header">
      <Container fluid>
        <Row spacing="md" align="center" justify="between">
          <Col md={4}>
            <div className="header__logo">
              <Image src={logo.imageSrc} alt={logo.alt} />
            </div>
          </Col>

          <Col md={4}>
            <div className="header__right flex items-center justify-end gap-xl">
              <span className="header__customer-name">{customerName}</span>
              <IconButton
                icon={<QuestionIcon size="2x" />}
                ariaLabel="Help"
                variant="secondary"
                size="lg"
                onClick={() => { window.open('https://support.six3ro.com', '_blank', 'noopener,noreferrer'); }}
              />
              <div className="header__messages relative">
                <IconButton
                  icon={<MessageIcon size="2x" />}
                  ariaLabel="Messages"
                  variant="secondary"
                  size="lg"
                />
                {messageCount > NO_MESSAGES && (
                  <span className="header__badge">{messageCount}</span>
                )}
              </div>

              <div className="header__user-anchor">
                <button
                  type="button"
                  className="header__initials-btn"
                  aria-haspopup="menu"
                  aria-expanded={menuOpen}
                  onClick={() => { setMenuOpen((value) => !value); }}
                >
                  <Avatar initials={customerInitials} size="md" />
                  <DropdownMenu
                    open={menuOpen}
                    onClose={() => { setMenuOpen(false); }}
                    menuItems={menuItems}
                  />
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default Header;
